import { z } from "zod";

import type { EcwEncounter } from "@/src/lib/ehr/ecw/webecw/endpoints/encounters";
import type { StepOutputs, WebecwProviderContext } from "@/src/lib/workflows/steps/step-outputs";
import type { Referral } from "@/src/models/documents/referral";
import type { Task } from "@/src/models/task";

import type { DateTime } from "luxon";

export enum WebecwTelEncNonCreationReason {
  NOT_NEEDED = "not_needed",
  UNKNOWN_CHART_ORIGIN = "unknown_chart_origin",
  EXISTING_TE = "existing_te",
  GUARD_UNAVAILABLE = "guard_unavailable",
  UNRESOLVED_ASSIGNEE = "unresolved_assignee",
  UNRESOLVED_DOCTOR = "unresolved_doctor",
  UNRESOLVED_FACILITY = "unresolved_facility",
  EXPLICIT_CREATE_FAILURE = "explicit_create_failure",
  UNCONFIRMED_CREATE_RESULT = "unconfirmed_create_result",
}

export const webecwTelEncOutcomeSchema = z.discriminatedUnion("created", [
  z.object({ created: z.literal(true), encounterId: z.string().trim().min(1) }).strict(),
  z.object({ created: z.literal(false), reason: z.nativeEnum(WebecwTelEncNonCreationReason) }).strict(),
]);

export type WebecwTelEncOutcome = z.infer<typeof webecwTelEncOutcomeSchema>;

export type CreateWebecwTelEncOutput = { encounterId: string };

export enum WebecwTelephoneEncounterDoctorSelectorKind {
  REFERRAL_NPI = "referral_npi",
  EXISTING_DOCTOR_ID = "existing_doctor_id",
}

export type WebecwTelephoneEncounterDoctorSelector =
  | {
      kind: WebecwTelephoneEncounterDoctorSelectorKind.REFERRAL_NPI;
      npi: string | null;
    }
  | {
      kind: WebecwTelephoneEncounterDoctorSelectorKind.EXISTING_DOCTOR_ID;
      doctorId: string | null;
    };

export interface BuildWebecwTelephoneEncounterDraftInput {
  task: Task;
  referral: Referral;
  created: boolean;
  providerContext: WebecwProviderContext;
  encounters: readonly EcwEncounter[];
  faxSenderNumber: string | null;
  stepOutputs: Readonly<StepOutputs>;
  at: DateTime;
}

export interface WebecwTelephoneEncounterDraft {
  reason: string;
  message: string;
  highPriority: boolean;
  doctorSelector: WebecwTelephoneEncounterDoctorSelector;
}
